import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex-direction-column" }
const _hoisted_2 = { class: "columns is-vcentered" }
const _hoisted_3 = { class: "column is-8" }
const _hoisted_4 = {
  id: "page-title",
  class: "title is-4 is-uppercase has-text-weight-medium is-inline"
}
const _hoisted_5 = {
  id: "members-count",
  class: "subtitle is-5 is-italic"
}
const _hoisted_6 = { class: "column is-4" }

import { CloseBold, Edit, Plus, Select } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import CreateMemberModal from '@/components/CreateMemberModal.vue';
import MemberAvatar from '@/components/MemberAvatar.vue';
import PasswordView from '@/components/PasswordView.vue';
import { canCreateMember, canEditMember } from '@/helpers/permission';
import { Member } from '@/Member/member.entity';
import MemberService from '@/Member/member.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberList',
  setup(__props) {

const members: Ref<Member[] | null> = ref(null);
const createMemberModalVisible: Ref<boolean> = ref(false);
const isPasswordViewOpen: Ref<boolean> = ref(true);
const newMember: Ref<Member | null> = ref(null);

const { t } = useI18n();
const router = useRouter();

const openPasswordViewModal = () => {
    isPasswordViewOpen.value = true;
};

const populateMembers = async (): Promise<void> => {
    const memberService = new MemberService();
    try {
        members.value = await memberService.findAll();
        members.value.sort((a, b) => a.lastName.localeCompare(b.lastName));
        members.value.sort((a, b) => a.firstName.localeCompare(b.firstName));
        members.value.sort((a, b) => b.isEnabled - a.isEnabled);
    } catch (error) {
        const { message } = error as { message: string };
        ElMessage.error(message);
    }
};

const onMemberCreated = (member: Member): void => {
    members.value = members.value || [];
    members.value.push(member);
    createMemberModalVisible.value = false;
    ElMessage.success(t('listMembers.memberCreated'));
    newMember.value = member;
    openPasswordViewModal();
};

const closePasswordViewModal = () => {
    isPasswordViewOpen.value = false;
    router.push({ name: 'member-form', params: { memberId: newMember.value?.memberId } });
};

populateMembers();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (members.value != null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('listMembers.members')), 1),
                _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(members.value.length) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_unref(canCreateMember)())
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      icon: _unref(Plus),
                      class: "button is-primary is-radius-small has-text-weight-semibold is-pulled-right",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (createMemberModalVisible.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('listMembers.addMember')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (members.value.length > 0)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: members.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _unref(t)('listMembers.name')
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(MemberAvatar, {
                          member: scope.row
                        }, null, 8, ["member"]),
                        _createTextVNode(" " + _toDisplayString(scope.row.firstName) + " " + _toDisplayString(scope.row.lastName), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref(t)('listMembers.email'),
                      prop: "email"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref(t)('listMembers.litigations'),
                      prop: "litigations"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString((Array.isArray(scope.row.litigations)
                                    ? scope.row.litigations
                                    : Object.values(scope.row.litigations ?? {})
                                )
                                    .map((litigation) => litigation.name)
                                    .join(', ')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref(t)('listMembers.isEnabled'),
                      prop: "isEnabled"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.isEnabled)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              color: "#03c03c"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Select))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              color: "#c23b22"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseBold))
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      fixed: "right",
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        (_unref(canEditMember)(scope.row))
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              icon: _unref(Edit),
                              underline: false,
                              href: 
                                    _unref(router).resolve({
                                        name: 'member-form',
                                        params: { memberId: scope.row.memberId },
                                    }).href
                                
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                              ]),
                              _: 2
                            }, 1032, ["icon", "href"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : (_openBlock(), _createBlock(_component_el_empty, { key: 1 }))
          ], 64))
        : _createCommentVNode("", true),
      (newMember.value && isPasswordViewOpen.value)
        ? (_openBlock(), _createBlock(PasswordView, {
            key: 1,
            email: newMember.value.email,
            password: newMember.value.password,
            onClose: closePasswordViewModal
          }, null, 8, ["email", "password"]))
        : _createCommentVNode("", true),
      (createMemberModalVisible.value)
        ? (_openBlock(), _createBlock(CreateMemberModal, {
            key: 2,
            onCreated: onMemberCreated,
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (createMemberModalVisible.value = false))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})